import React from 'react';
import { Calendar, MessageCircle, Sparkles } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '01',
    title: 'Book a Free Consultation',
    description: "Reach out to book a free 15-minute phone consultation. We'll discuss your needs and see if we're a good fit.",
    icon: Calendar
  }, {
    number: '02',
    title: 'Discuss Your Goals',
    description: "In our first full session, we'll explore your concerns, set therapy goals, and create a personalised treatment plan.",
    icon: MessageCircle
  }, {
    number: '03',
    title: 'Begin Your Healing Journey',
    description: 'Start your journey toward healing with regular sessions — in-person in London or virtually across Ontario.',
    icon: Sparkles
  }];
  return <section id="how-it-works" className="py-12 lg:py-16 bg-white" data-id="element-390">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-391">
        <div className="text-center max-w-xl mx-auto mb-10" data-id="element-392">
          <span className="text-olive font-bold uppercase tracking-widest text-[11px] mb-3 block" data-id="element-393">
            GETTING STARTED
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-charcoal mb-3" data-id="element-394">
            How To Get Started
          </h2>
          <p className="text-charcoal/70 text-sm font-medium" data-id="element-395">
            You are making a courageous step. I have immediate availability — no
            waitlist.
          </p>
        </div>

        <div className="relative" data-id="element-396">
          <div className="hidden md:block absolute top-10 left-[15%] right-[15%] h-px bg-charcoal/10" data-id="element-397" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-6" data-id="element-398">
            {steps.map(step => {
            const Icon = step.icon;
            return <div key={step.number} className="relative flex flex-col items-center text-center" data-id="element-399">
                  <div className="w-20 h-20 rounded-xl bg-charcoal/5 flex items-center justify-center mb-4 relative" data-id="element-400">
                    <span className="absolute -top-2 -right-2 w-7 h-7 rounded-full bg-gold text-white text-xs font-bold flex items-center justify-center" data-id="element-401">
                      {step.number}
                    </span>
                    <Icon size={28} className="text-charcoal" strokeWidth={1.5} data-id="element-402" />
                  </div>
                  <h3 className="font-heading text-base font-bold text-charcoal mb-2" data-id="element-403">
                    {step.title}
                  </h3>
                  <p className="text-charcoal/70 text-xs max-w-[260px] mx-auto font-medium leading-relaxed" data-id="element-404">
                    {step.description}
                  </p>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}